import { Component } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-page-service-session-identity-verification-response',
    templateUrl: './page-service-session-identity-verification-response.component.html',
    styleUrls: ['./page-service-session-identity-verification-response.component.scss'],
    standalone: false
})
export class PageServiceSessionIdentityVerificationResponseComponent {

    constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute
    ) {}

    public goToMangoPayDocuments(): void{

        this._router.navigate(['account/service/list'], { queryParams : { targetTab: 'document' }});
    }

    get sessionId(): string {

        return (this._activatedRoute.snapshot.params['reference']);
    }

    get response(): string {

        return this._activatedRoute.snapshot.params['response'];
    }

    get status(): string {

        return (this._activatedRoute.snapshot.params['status']);
    }
}
